export default {
    data() {
        return {
            successNotification: {
                isActive: false,
                massage: '',
            },
            errorNotification: {
                isActive: false,
                massage: '',
            },
            validateErrors: []
        }
    },
    methods: {
        showSuccessNotification(message) {
            this.successNotification.isActive = true;
            this.successNotification.massage = message;

            setTimeout(() => {
                this.successNotification.isActive = false;
                this.successNotification.massage = '';
            }, 2000);
        },
        showErrorNotification(message) {
            this.errorNotification.isActive = true;
            this.errorNotification.massage = message;

            setTimeout(() => {
                this.errorNotification.isActive = false;
                this.errorNotification.massage = '';
            }, 10000);
        },
        clearValidateErrors() {
            this.validateErrors = [];
        },
        setValidateErrors(errors) {
            this.clearValidateErrors();

            for (const field in errors) {
                this.validateErrors[field] = errors[field][0];
            }
        },
        messageFieldError(field) {
            if (this.validateErrors[field]) {
                return this.validateErrors[field];
            }

            return '';
        }
    }
}
